import {ExpertSystemHierarchyNode} from '../types'

export function findNodeInHierarchy(
  nodeId: string,
  hierarchy?: ExpertSystemHierarchyNode
): ExpertSystemHierarchyNode | undefined {
  if (!hierarchy) return undefined
  if (hierarchy.id === nodeId) return hierarchy

  for (const child of hierarchy.children || []) {
    const found = findNodeInHierarchy(nodeId, child)
    if (found) return found
  }
}
